/**
   * @ngdoc directive
   * @name adjust.directive:productUpdates
   * @scope
   * @restrict E
   *
   * @description
   * Listing the product updates
   *
   */
function productUpdates() {
  'ngInject';
  return {
    restrict: 'E',
    template: require('./product-updates.html'),
    scope: {},
    controller: 'ProductUpdatesController',
    controllerAs: 'vm',
    bindToController: {
      productUpdates: '=updates',
      showUnseen: '@?'
    }
  };
}

/**
   * @ngdoc controller
   * @name adjust.controller:ProductUpdatesController
   *
   * @description
   * All the functionality of the {@link adjust.directive:productUpdates productUpdates} directive
   *
   */
function ProductUpdatesController() {
  'ngInject';
  var vm = this;

  vm.seen = seen;

  /**
   * @ngdoc method
   * @name seen
   * @methodOf adjust.controller:ProductUpdatesController
   *
   * @description
   * Set seen_at for the given product update
   *
   * @param {Object} productUpdate
   */
  function seen(productUpdate) {

    productUpdate.seen_at = new Date();

  }
}

export { ProductUpdatesController, productUpdates };
